import type { Schema } from '../../Entities/Schema.entity';
import { createSchema } from '../../Utils/CreateSchema';

export const ppUserSchema: Schema = {
  ...createSchema({
    version: '1-1-1',
    description: 'Purchase Pro user information',
    name: 'pp_user',
    properties: {
      user_id: {
        type: 'string',
        description: 'Unique identifier of the user',
      },
      first_name: {
        type: 'string',
        description: 'The first name of the user',
      },
      last_name: {
        type: ['string', 'null'],
        description: 'The last name of the user',
      },
      email: {
        type: 'string',
        description: 'The email of the user',
      },
      phone: {
        type: ['string', 'null'],
        description: 'The phone number of the user',
      },
      role: {
        type: ['string', 'null'],
        description: "The user's role within the Purchase Pro app at the time of the event",
      },
    },
    required: ['user_id', 'first_name', 'email'],
  }),
};
